import React from 'react';

const TopBarSaveButtonWrapper = (Original, system) => {
  const Wrapper = (props) => {
    const { backendSpecsActions, backendSpecsSelectors } = system;

    return (
      <Original
        {...props}
        backendSpecsActions={backendSpecsActions}
        backendSpecsSelectors={backendSpecsSelectors}
      />
    );
  };

  return Wrapper;
};

export default TopBarSaveButtonWrapper;
